import { DUPE_API_URL } from '@dupe/common/constants'
import { OnboardingData } from '@dupe/data/schema'
import { useMutation } from '@tanstack/react-query'
import useAuthUser from '~/src/hooks/useAuthUser'
import fetcher from '~/src/lib/fetcher'

interface MaybeRegisterResponse {
  user: {
    id: string | null
    tempUserIds: string[] | null
    isAnonymous: boolean | null
    metadata: Record<string, any> | null
    onboarding_data: OnboardingData | null
    createdAt: Date | null
  }
  existing: boolean
}

export const useMaybeRegister = () => {
  const { authUser } = useAuthUser()

  return useMutation({
    mutationFn: async () => {
      const data = await fetcher<MaybeRegisterResponse>(
        `${DUPE_API_URL}/api/user/maybe-register`,
        {
          method: 'POST',
          authUser,
        }
      )
      return data
    },
  })
}
